import { render, staticRenderFns } from "./UpsertRestriction.vue?vue&type=template&id=130d924b&scoped=true"
import script from "./UpsertRestriction.vue?vue&type=script&lang=ts"
export * from "./UpsertRestriction.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "130d924b",
  null
  
)

export default component.exports